import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import Content from "../Modulos/Desvios/Investigacao/Content";

const Investigacoes = () => {

    return(
        <>
            <NavBar title="INVESTIGAÇÕES" goBackOnePage />
            <GenericBody>
                <Content />
            </GenericBody>
        </>
    )

}

export default Investigacoes;